export default __webpack_public_path__ + "static/media/icon.e26cffee.png";